var map = {
	"./acciona-bw.png": 6618,
	"./anglo-bw.png": 4083,
	"./codelco-bw.png": 7667,
	"./comtecsa-bw.png": 5655,
	"./geovita-bw.png": 2097,
	"./sigma-bw.png": 89,
	"./techint-bw.png": 9771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2428;